{
  "title": "Icingdeath's Frost (UA)",
  "source": "Unearthed Arcana 78 - Draconic Options",
  "levelAndSchool": "2nd-level evocation",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self (15-foot cone)",
  "components": "S, M (a vial of meltwater)",
  "duration": "Instantaneous",
  "description": [
    "A burst of icy cold energy emanates from you in a 30-foot cone. Each creature in that area must make a Constitution saving throw. On a failed save, a creature takes 3d8 cold damage and is covered in ice for 1 minute or until a creature uses its action to break the ice off itself or another creature. A creature covered in ice has its speed reduced to 0. On a successful save, a creature takes half as much damage with no additional effects.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, increase the cold damage by 1d8 for each slot level above 2nd."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "wizard"]
}
